import api from "./core";

const basePath = "api/{{serverSegment}}/Emar";

export default {
  query(patientId, extraHeaders = {}, from = null, to = null) {
    let url = `${basePath}/${patientId}`;
    const params = new URLSearchParams();
    
    if (from) {
      params.append('from', from);
    }
    
    if (to) {
      params.append('to', to);
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    return api.post(url, extraHeaders);
  },
  getVitals(patientId, from = null, to = null, extraHeaders = {}) {
    let url = `${basePath}/${patientId}/Vitals`;
    const params = new URLSearchParams();
    
    if (from) {
      params.append('from', from);
    }
    
    if (to) {
      params.append('to', to);
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    return api.post(url, extraHeaders);
  },
  getDispenseReport(patientId, from = null, to = null, extraHeaders = {}) {
    let url = `${basePath}/${patientId}/DispenseReport`;
    const params = new URLSearchParams();
    
    if (from) {
      params.append('from', from);
    }
    
    if (to) {
      params.append('to', to);
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    return api.post(url, extraHeaders);
  },
};
